<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>

<div class="k-overlay" *ngIf="editWinOpen"></div>

<div class="container" my-5>
  <div class="card" #appendTo>
    <div class="card-body no-border">
      <div class="card-title">
        <h3 style="text-align: left;" class="page-header">
          <fa-icon class="fa-solid fa-duotone" [icon]="['fad', 'users']"></fa-icon> Manage Users
        </h3>
      </div>

      <kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true"
        [groupable]="true" [resizable]="true" [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
        (sortChange)="sortChange($event)" style="height: calc(100vh - 200px); min-height: 400px;" [pageSize]="pageSize"
        [pageable]="true">

        <ng-template kendoGridToolbarTemplate position="top">
          <button [hidden]="!canCreate" (click)="showAddWindow(windowTitleBar)" kendoButton class="btn btn-primary">
            <fa-icon icon="circle-plus"></fa-icon> Add
            New User
          </button>
        </ng-template>

        <kendo-grid-column title="Edit" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canUpdate" (click)="showEditWindow(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="edit"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="first_name" title="First Name" [width]="150">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="last_name" title="Last Name" [width]="150">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="email" title="Email" [width]="250">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column field="phone" title="Phone" [width]="150">
          <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
            let-filterService="filterService">
            <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
              [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
          </ng-template>
        </kendo-grid-column>

        <kendo-grid-column title="Activate/Deactivate" field="active" [width]="130" [filterable]="false">
          <ng-template kendoGridCellTemplate let-dataItem>
            <input [hidden]="!canDestroy" type="checkbox" kendoCheckBox size="large" [checked]="dataItem.active"
              (click)="toggleActive(dataItem)" />
          </ng-template>
        </kendo-grid-column>

        <!-- <kendo-grid-column title="Delete" [width]="70">
          <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
            <button [hidden]="!canDestroy" (click)="openConfirmDailog(dataItem)" kendoButton class="btn btn-stn-grid">
              <fa-icon icon="trash"></fa-icon>
            </button>
          </ng-template>
        </kendo-grid-column> -->

        <ng-template kendoPagerTemplate>
          <kendo-pager-info *ngIf="pageSize > 0"></kendo-pager-info>
        </ng-template>
      </kendo-grid>

    </div>
  </div>

</div>

<div kendoWindowContainer></div>

<div kendoDialogContainer></div>
